import * as React from 'react';
import cx from 'classnames';

import './radio.styles.scss';

export type RadioProps = React.PropsWithChildren<{
  className?: string;
  label?: React.ReactNode;
  classes?: {
    label?: string;
    input?: string;
  }
}> & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const Radio: React.FC<RadioProps> = (props) => {
  const { classes, label: labelContent, className, children, ...otherProps } = props;

  return (
    <div className={cx('radio', 'Radio', className)}>
      <label className={classes?.label}>
        <input 
          {...otherProps}
          className={classes?.input}
          type="radio"
        />
        {labelContent || children}
      </label>
    </div>
  );
};

